// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1280":"a513b1fd","1372":"fac77a46"}[chunkId] || chunkId) + "." + {"506":"c071f1f280b35365","1280":"14d926389051f71d","1372":"3daf207eb17c755b","6561":"c8472b1de566b461"}[chunkId] + ".js";
};